module.exports = __webpack_public_path__ + "img/aqxx.6e6a7b03.png";